export const KanbanCardConstants = {
  FieldConstants: {
    CardFieldLeftCorner : 'CardFieldLeftCorner',
    CardFieldRightCorner : 'CardFieldRightCorner',
    CardFieldRightCount : 'CardFieldRightCount',
  }
};

export const KanbanCardAllFieldConstants = 
  Object.values(KanbanCardConstants.FieldConstants);